export const loginSideBanner = {
  IDV: {
    title: "Lystproof:  Digitally Verified Employment Data as a Service",
    points: [
      "Streamline the employment data verification process",
      "Digitally maintain individual records",
      "Share verified documents through Lystproof",
      "Integrate with HRMS and payroll software for seamless data flow",
    ],
    imageUrl: "/images/login-side-banner.svg",
  },
  VFR: {
    title: "Lystproof:  Digitally Verified Employment Data as a Service",
    points: [
      "Streamline the employment data verification process",
      "Digitally maintain individual records",
      "Share verified documents through Lystproof",
      "Integrate with HRMS and payroll software for seamless data flow",
    ],
    imageUrl: "/images/login-side-banner.svg",
  },
  ORG: {
    title: "Lystproof:  Digitally Verified Employment Data as a Service",
    points: [
      "Streamline the employment data verification process",
      "Digitally maintain individual records",
      "Share verified documents through Lystproof",
      "Integrate with HRMS and payroll software for seamless data flow",
    ],
    imageUrl: "/images/login-side-banner.svg",
  },
};

export const loginDefaultBanner = {
  title: "Lystproof:  Digitally Verified Employment Data as a Service",
  points: [
    "Streamline the employment data verification process",
    "Digitally maintain individual records",
    "Share verified documents through Lystproof",
    "Integrate with HRMS and payroll software for seamless data flow",
  ],
  imageUrl: "/images/login-side-banner.svg",
};
export const PUBLIC_SKIP_DASHBOARD_REDIRECT = ["/reset-password", "/share"];

export const userTypeTypeNameToKeyMap = {
  organization: "ORG",
  individual: "IDV",
  "commercial-verifier": "VFR",
};

export const companyAccountType = ["ORG", "VFR"];
